import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, moduleTypeNames } from "../../../framework/core/mvvm/module_base";
import ClubMemberView, { member_page } from "./club_member_view";
import ModuleManager from "../../../framework/core/module_manager";
import ClubHallModule from "../hall/club_hall_module";
import ClubMemberPopModule from "./club_member_pop_module";
import { club_utils } from "../club_utils";
import { friend_utils } from "../../hall/module/friend/friend_utils";
;

const {ccclass, property} = cc._decorator;


@ccclass
@moduleInit("ClubMemberModule")
export default class ClubMemberModule extends ModuleBase<ClubMemberView,null> {


    constructor(){
        super();

        this.layer = ViewLayer.Mid;
        this.modelType = null;
        this.viewType = ClubMemberView;
        this.needViewMask = true
        this.clickAnywhereClose = false;
        this.windowPrefabResPath = "package/club/module/club_member"
        
    }

    onLoad(){
        this.eventBind("club_request_set_currency",this.on_club_request_set_currency);
        this.eventBind("club_request_remove_club",this.on_club_request_remove_club);
        this.eventBind("club_request_add_friend",this.on_club_request_add_friend);
        this.eventBind("club_click_member_item",this.on_club_click_member_item);
        this.eventBind("club_audit_accept",this.on_club_audit_accept);
        this.eventBind("club_audit_refuse",this.club_audit_refuse);
        this.eventBind("club_request_invite_join",this.on_club_request_invite_join)
        
    }

    onShow(data:any){
        
    }

    private on_club_request_set_currency( index : number,coins:number){

        club_utils.reqSetBalance(coins,index,this,(balance)=>{
            
            this.view.updateBanlace(index,balance);
        })
      
    }

  
    private on_club_request_remove_club(index : number){

        club_utils.reqRemoveClub(index,this,(result)=>{
            if (result) {                    
                this.view.removeItem(index);
            }else{

            }
        })
    }

    private on_club_request_add_friend(index : number){

        let friendId = club_utils.getMember(index).gameUserId;
        friend_utils.addFriend(friendId,this,(result)=>{
            if (result) {
                
            }else{

            }
        });
    }


    private on_club_click_member_item(index : number) {
        
        ModuleManager.instance.showModule(ClubMemberPopModule,{index:index , data :this.view.getListItemData(index)}); 
    }

    private on_club_audit_accept(index : number){

        club_utils.reqAcceptJoinClub(true,index,this,()=>{
            //刷新审核列表
            this.view.requestAudit();
        });
    }

    private on_club_request_invite_join(index : number){

    }

    private club_audit_refuse(index : number){

        club_utils.reqAcceptJoinClub(false,index,this,()=>{
            //刷新审核列表
            this.view.requestAudit();
        });
    }

    @bindButtonClickEvent("close")
    onClose(){
        this.hide();
    }

    @bindButtonClickEvent("serach_button")
    onSearch(){
        let searchId = Number(this.view.serachEditBox.string);

        if (this.view.curType == member_page.member) {
            
            this.view.curType = member_page.searchMember;

            club_utils.reqMemberList(1,this,(result)=>{
                if (result) {
                    this.view.updateListView();
                }else{

                }
            },searchId)
        }else if(this.view.curType == member_page.audit){

            this.view.curType = member_page.searchAudit;

            club_utils.reqAuditList(1,this,(result)=>{

                if (result) {
                    this.view.updateListView();
                }else{

                    
                }
            },searchId);
        }
       
    }

    @bindButtonClickEvent("return")
    onReturn(){

        ModuleManager.instance.showModule(ClubHallModule,null,()=>{
            this.hide();
        });
    }


}
